import React, { useEffect, useRef, useState } from "react";
import GameInProgressStyles from '../../GameInProgress/GameInProgress.module.css'
import Styles from './Sandbox.module.css';
import { Sam } from "../../Rive/RiveComponent";
import { MediaCaptureProvider } from "../../context/MediaCaptureContext";
import AudioRecorderComponent from "../../Media/MediaComponent/AudioRecorderComponent";
import VideoRecorderComponent from "../../Media/MediaComponent/VideoRecorderComponent";
import uploadFile, { getFileType } from "../../../utils/mediaUtils";
import TakePhotoComponent from "../../Media/MediaComponent/TakePhotoComponent";
import ControlledMediaPlayer from "../../Media/MediaPlater/ControlledMediaPlayer";
import { RECORDING_MODE } from "../../../utils/constants";

import "../../Qualification/Qualification.css";
import icoQOff from '../../../assets/ico-q-off.svg';
import icoQOn from '../../../assets/ico-q-on.svg';
import txtIndicator from '../../../assets/text-indicator.svg';

import CloseCaptionButton from "../../Buttons/CloseCaptionButton";
import SyncedSubtitle from "../../Subtitles/SyncedSubtitle";
import SubtitleRenderer from "../../Subtitles/SubtitleRenderer";

const mockGameState = {
    current_question: {
        "id": "MOCK_AUDIO",
        "module": "1",
        "tiempoRespuesta": 60,
        "challenge": "Cuando hablamos de los principios básicos de higiene en la manipulación, preparación, elaboración, envasado, estamos haciendo referencia a las Buenas Prácticas de Almacenamiento - BPA.",
        "respuestaCorrecta": false,
        "feedbackFalsoVerdadero": "Buenas Prácticas de Manufactura",
        "tipoDesafio": "soloTexto",
        "esFalsoVerdadero": true,
        "company": "oSO5DqPaHtsP7moxREr0",
        "cardType": "desafioConocimiento",
        "room": "1",
        "tipoRespuesta": "audio",
        url: [
            // testVideoSource
        ]
    },
    questions: [
        {
            
        }
    ],
    current_answer_qualification: {
        // answer: testVideoSource
        // answer: testAudioSource
    }
}

const Sandbox = () => {
    const timer = 10;
    const animation = 1;
    const dropdownOptions = [
        {
            label: "Audio",
            value: "audio"
        },
        {
            label: "Video",
            value: "video"
        },
        {
            label: "Foto",
            value: "photo"
        },
        {
            label: "Reproducir audio",
            value: "audio-player"
        },
        {
            label: "Calificación",
            value: "rate-answer"
        },
    ]
    const [selectedOption, setSelectedOption] = useState("");
    const audioRef = useRef();
    const videoRef = useRef();

    const [animated, setAnimated] = useState(false);
    const [isOwnAnswer, setIsOwnerAnswer] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);

    const handleConfirm = (isAnimating = 1) => {
        if (isAnimating) {
            setAnimated(false);
            // playAnimation(ANIMATIONS.talking, 4);
            // setTimeout(() => {
            //     setSamTalking(false);
            // }, 4000);
        }
    };

    useEffect(() => {
        if(selectedOption === "rate-answer") {
            setRating(0);
            setAnimated(true);
        }
    }, [selectedOption])

    // =================================================================
    // Subtitles code
    // =================================================================
    const [subtitle, setSubtitle] = useState('');
    const [isCCActive, setIsCCActive] = useState(false);
    const toggleCC = () => {
        if(isCCActive) {
            setSubtitle('');
        }
        setIsCCActive(!isCCActive);
    };
    const handleSubtitleChange = (text) => {
        if(isCCActive) {
            setSubtitle(text);
        }
    }
    // =================================================================

    return (
        <div className={Styles.sandboxContainer}>
            <span>v100925</span>
            <div id="clouds">
                <div className="cloud x1"></div>
                <div className="cloud x2"></div>
                <div className="cloud x3"></div>
                <div className="cloud x4"></div>
                <div className="cloud x5"></div>
            </div>
            <div className={GameInProgressStyles.screen}>

                {/* dropdown component picker */}
                <div className={Styles.pickComponentContainer}>
                    <label htmlFor="componentPicker">{`Elegir componente: `}</label>
                    <select 
                        name="componentPicker" 
                        id="componentPicker"  
                        value={selectedOption}
                        onChange={e => setSelectedOption(e.target.value)}>
                        <option value="" >Seleccionar...</option>
                        {dropdownOptions.map((option, index) => (
                            <option 
                                key={`option_${index}_${option.value}`} 
                                value={option.value}
                            >
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Animated character */}
                <div className={GameInProgressStyles.imgSam}>
                    <Sam animation={animation} />
                </div>

                <div className={GameInProgressStyles.curtain}>
                    <div className={GameInProgressStyles.zigZagLineV}> </div>
                </div>

                <div className={GameInProgressStyles.gameInProgress}>

                    {/* question component flow */}
                    <div className="question-container">
                        {["video", "audio", "photo"].includes(selectedOption) &&
                        <div className="TextboxContainer">
                            <div className="Textbox">
                                <p>{mockGameState.current_question.challenge}</p>
                            </div>
                        </div>}
                        {selectedOption === "audio" &&
                        <MediaCaptureProvider defaultMediaUrl={mockGameState.current_answer_qualification.answer || ""} mode={RECORDING_MODE.audio}>
                            <AudioRecorderComponent timer={timer} submitDisabled={mockGameState.current_answer_qualification.answer.length > 0} onConfirmAudio={async (url, blob) => {
                                console.log("url", url, "blob", blob);
                                // uploadFile(blob, "audio-recording");
                            }} />
                        </MediaCaptureProvider>}
                        {selectedOption === "video" &&
                        <MediaCaptureProvider defaultMediaUrl={mockGameState.current_answer_qualification.answer || ""}>
                            <VideoRecorderComponent timer={timer} submitDisabled={mockGameState.current_answer_qualification.answer.length > 0}  onConfirmVideo={async (url, blob) => {
                                console.log("url", url, "blob", blob);
                                // uploadFile(blob, "video-recording");
                            }} />
                        </MediaCaptureProvider>}
                        {selectedOption === "photo" &&
                        <MediaCaptureProvider mode={RECORDING_MODE.photo} submitDisabled={mockGameState.current_answer_qualification.answer.length > 0} >
                            <TakePhotoComponent timer={timer} submitDisabled={mockGameState.current_answer_qualification.answer.length > 0} onConfirmPhoto={async (url, blob) => {
                                console.log("url", url, "blob", blob);
                                // uploadFile(blob, "photo");
                            } } />
                        </MediaCaptureProvider>}
                    </div>

                    {/* partial answer component */}
                    {selectedOption === "audio-player" &&
                    <div className="w-full fix-left-on-mobile flex items-center justify-center">
                        <ControlledMediaPlayer
                            ref={audioRef}
                            mediaUrl={mockGameState.current_answer_qualification}
                        />
                    </div>}

                    {/* rate answer */}
                    {selectedOption === "rate-answer" && 
                    <div className="queContainer">
                        <div className={`blockContent ${animated ? "show" : ""}`}>

                            <div className={`TextboxContainer`}>
                                <div className="Textbox">
                                    <div>
                                        <label>{mockGameState.current_question.challenge}</label>
                                        {/* Verificar si hay al menos una URL */}
                                        {mockGameState.current_question.url && mockGameState.current_question.url.length > 0 && (
                                            <div className="media-gallery">
                                                {(() => {
                                                    const mediaUrl = mockGameState.current_question.url[0];
                                                    const fileType = getFileType(mediaUrl);

                                                    if (fileType === "image") {
                                                        return <img src={mediaUrl} alt="Imagen de la pregunta" className="question-image" />;
                                                    } else if (fileType === "video") {
                                                        return <div className="flex items-center justify-center">
                                                            <SyncedSubtitle ref={videoRef} onCloseCaptionChange={handleSubtitleChange} />
                                                            <SubtitleRenderer text={subtitle} isActive={isCCActive} isAbsolute />
                                                            <video ref={videoRef} src={mediaUrl} controls className="question-video" />
                                                        </div>;
                                                    } else {
                                                        return <p className="unsupported-media">Tipo de archivo no soportado</p>;
                                                    }
                                                })()}
                                            </div>
                                        )}
                                    </div>

                                    {
                                    <div className="textNotQualification">
                                        <label><b style={{ fontWeight: '700', fontSize: '23px', color: '#00b6ff' }}>Los demás viajeros están calificando tu respuesta</b></label>
                                        <img className="txtIndicator" src={txtIndicator} alt="txt indicator" />
                                    </div>}
                                </div>
                            </div>

                            <div className="mediaContainer">

                                {!isOwnAnswer && mockGameState.current_answer_qualification && 
                                <div className="center">
                                    {mockGameState.current_answer_qualification.answer === "no_answer" && 
                                    <div className="whitebox-purple-border">
                                        <p>¡Oh! Un viajero no respondió a tiempo</p>
                                    </div>}

                                    {mockGameState.current_question.tipoRespuesta === "foto" &&
                                    <div className="flex items-center justify-center">
                                        <img src={mockGameState.current_answer_qualification.answer} alt="Respuesta del usuario" className="image-box" />
                                    </div>}

                                    {mockGameState.current_question.tipoRespuesta === "video" &&
                                    <div className="flex items-center justify-center">
                                        <SyncedSubtitle ref={videoRef} onCloseCaptionChange={handleSubtitleChange} />
                                        <SubtitleRenderer text={subtitle} isActive={isCCActive} isAbsolute />
                                        <video className="video-box" ref={videoRef} autoPlay src={mockGameState.current_answer_qualification.answer} controls />
                                    </div>}

                                    {mockGameState.current_question.tipoRespuesta === "audio" &&
                                    <div className="flex flex-col justify-center gap-1">
                                        <SyncedSubtitle ref={audioRef} onCloseCaptionChange={handleSubtitleChange} />
                                        <SubtitleRenderer text={subtitle} isActive={isCCActive} />
                                        <div className="flex items-center justify-center">
                                            <ControlledMediaPlayer ref={audioRef} mediaUrl={mockGameState.current_answer_qualification.answer} />
                                        </div>
                                    </div>}

                                    {mockGameState.current_question.tipoRespuesta === "texto" && mockGameState.current_answer_qualification.answer !== "no_answer" &&
                                    <div className="whitebox-purple-border">
                                        <p className="answer-text">{mockGameState.current_answer_qualification.answer}</p>
                                    </div>}
                                </div>}
                                
                                {!isOwnAnswer && !mockGameState.current_answer_qualification &&
                                    <div className="whitebox-purple-border">
                                        <p>No hay respuestas para calificar</p>
                                    </div>}
            
                                {!isOwnAnswer && mockGameState.current_answer_qualification && mockGameState.current_answer_qualification.answer !== "no_answer" &&
                                <div className="center">
                                    <div className="rating-stars yellowbox-purple-border">
                                        {[...Array(5)].map((_, index) => {
                                            const ratingValue = index + 1;
                                            return (
                                                <label key={index}>
                                                    <input type="radio" name="rating" value={ratingValue} onClick={() => setRating(ratingValue)} disabled={isConfirmed} />
                                                    <img className="star" src={ratingValue <= (hover || rating) ? icoQOn : icoQOff} alt="logo game" onMouseEnter={() => setHover(ratingValue)} onMouseLeave={() => setHover(0)} />
                                                </label>
                                            );
                                        })}
                                    </div>
        
                                    <button className="ConfirmButton" onClick={handleConfirm} disabled={rating === 0 || isConfirmed}>
                                        <div className="principalBtn">
                                            {isConfirmed ? 'Enviado' : 'Enviar'}
                                        </div>
                                    </button>
                                </div>}
                            </div>
                        </div>

                        <div className={`slideContent ${!animated ? "show-greeting" : ""}`}>
                            <div className={`TextboxContainer`}>
                                <div className="Textbox">
                                    <div>
                                        <label>Gracias por calificar</label>
                                        <img className="txtIndicator" src={txtIndicator} alt="txt indicator" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>

            <CloseCaptionButton isActive={isCCActive} onClick={toggleCC} />
        </div>
    )
}

export default Sandbox